import { useMutation } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';
import { useStore } from '../../store';
import { ContextType, IServerErrorResponse } from '../../types';
import { handleOnAchOutError } from '../../generic-components/MFA/services/onMfaErrorService';
import { IMfaErrorData } from '../../generic-components/MFA/types';
import { ContextTypes } from '../../constants/pages';

interface IProps {
    payload: any;
}

interface IVerifyAchOutProps {
  onVerifyError: (errorData: IMfaErrorData) => void
  contextType?: ContextType;
  billId?: string;
}

export function useVerifyAchOut({ contextType = ContextTypes.ACH_OUT, billId, onVerifyError }: IVerifyAchOutProps) {
  const { user: { customerId }, getPersonalAccount } = useStore(state => state);
  const { accountExternalId } = getPersonalAccount();
  const requestURL = contextType === ContextTypes.BILL_PAY
    ? `${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/${billId}/ach/out/billPay/mfaVerify`
    : `${BASE_URL}/api/v2/user/${customerId}/${accountExternalId}/ach/out/mfaVerify`;
  return useMutation(
    'useVerifyAchOut',
    async ({ payload }: IProps) => {
      const res = await httpService.post(requestURL, payload);
      return res.data;
    },
    {
      onError: (error: IServerErrorResponse) => {
        const errData = handleOnAchOutError(error);
        onVerifyError(errData);
      },
    },
  );
}
